import React from "react";
import { Routes, Route } from "react-router-dom";

// Import Routes all
import { authProtectedRoutes, publicRoutes, physicianRoutes } from "./routes";

// Import all middleware
// import Authmiddleware from "./routes/route";
// import NonAuthLayout from "./components/nonAuthLayout";
// import AuthLayout from "./components/authLayout";
// import PhysicianLayout from "./layouts/PhysicianLayout";
import AppRouter from "./routes/AppRouter";
import GlobalUnsavedChangesDialog from "./components/GlobalUnsavedChangesDialog";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function App() {
  // return (
  //   <div className="App">
  //     <header className="App-header">
  //       <img src={logo} className="App-logo" alt="logo" />
  //       <p>
  //         Edit <code>src/App.js</code> and save to reload.
  //       </p>
  //       <a
  //         className="App-link"
  //         href="https://reactjs.org"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         Learn React
  //       </a>
  //     </header>
  //   </div>
  // );

  return (
    // <React.Fragment>
    //   <Routes>
    //     {publicRoutes.map((route, idx) => (
    //       <Route
    //         path={route.path}
    //         element={<NonAuthLayout>{route.component}</NonAuthLayout>}
    //         key={idx}
    //         exact={true}
    //       />
    //     ))}

    //     {authProtectedRoutes.map((route, idx) => (
    //       <Route
    //         path={route.path}
    //         element={
    //           <Authmiddleware>
    //             <AuthLayout>{route.component}</AuthLayout>
    //           </Authmiddleware>
    //         }
    //         key={idx}
    //         exact={true}
    //       />
    //     ))}

    //     {physicianRoutes.map((route, idx) => (
    //       <Route
    //         path={route.path}
    //         element={
    //           <Authmiddleware>
    //             <PhysicianLayout>{route.component}</PhysicianLayout>
    //           </Authmiddleware>
    //         }
    //         key={idx}
    //         exact={true}
    //       />
    //     ))}
    //   </Routes>
    // </React.Fragment>
    <Elements stripe={stripePromise}>
      <AppRouter />
      <GlobalUnsavedChangesDialog />
    </Elements>
  );
}

export default App;
